var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.65 11.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f8f9fa;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_11",
    "data-name": "Layer 11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ozgLYT"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.76,1.37a3.29,3.29,0,0,1,1.17.54,3.12,3.12,0,0,1,1.23,2,4.41,4.41,0,0,1,.1,1c0,.71,0,1.41,0,2.12a3.35,3.35,0,0,0,.38,1.58,12.8,12.8,0,0,0,.79,1.27.53.53,0,0,1,.08.25.29.29,0,0,1-.32.28H3.48a.33.33,0,0,1-.31-.16.32.32,0,0,1,0-.35c.23-.34.46-.68.67-1A3.47,3.47,0,0,0,4.36,7.4a7.85,7.85,0,0,0,0-.84V4.7a3.6,3.6,0,0,1,.54-1.94A3.11,3.11,0,0,1,6.78,1.39c.08,0,.11,0,.11-.13a2.26,2.26,0,0,1,0-.45A.93.93,0,0,1,8.76.92Zm-.62-.12c0-.11,0-.22,0-.34A.3.3,0,0,0,7.84.62a.3.3,0,0,0-.32.26,2.29,2.29,0,0,0,0,.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.55,8.92,14,8.6a7.06,7.06,0,0,0,0-7.2l.5-.31A7.55,7.55,0,0,1,14.55,8.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.09,1.09l.51.31a7.09,7.09,0,0,0,0,7.2l-.51.32A7.31,7.31,0,0,1,0,5.69,7.45,7.45,0,0,1,1.09,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.67,2.25l.53-.33a5.78,5.78,0,0,1,0,6.16l-.52-.32A5.35,5.35,0,0,0,13.46,5,5.12,5.12,0,0,0,12.67,2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3,7.77l-.53.31A6,6,0,0,1,1.58,5.4a5.66,5.66,0,0,1,.87-3.47L3,2.24A5.25,5.25,0,0,0,3,7.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.24,11a1.54,1.54,0,0,1-2.83,0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.4b44825b01ab6d75704343ca1c42d64a.svg";
export { ForwardRef as ReactComponent };